import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AddEventViewsRequest } from "@ac-expo/api-types";
import { privateAxios } from "../axiosInstances";
import { acExpoQueryKeys } from "../query-keys/ac-expo.query-keys";

const addEventViews = async (data: AddEventViewsRequest) => {
  const response = await privateAxios.post("/ac-expo/add-event-views", data);
  return response.data;
};

export const useAddEventViews = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: AddEventViewsRequest) => addEventViews(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: acExpoQueryKeys.allManualViewsHistory(),
      });
    },
  });
};
